"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Vahagn Lazyan.
 * @since 1.3.0
 */
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var Subject_1 = require("rxjs/Subject");
require("rxjs/add/observable/combineLatest");
require("rxjs/add/observable/of");
require("rxjs/add/observable/zip");
require("rxjs/add/operator/map");
require("rxjs/add/operator/mergeMap");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_frontend_shared_1 = require("@synisys/idm-frontend-shared");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var portfolio_row_model_1 = require("./portfolio-row.model");
var portfolio_cell_model_1 = require("./portfolio-cell.model");
var services_1 = require("../../services");
var DynamicPortfolioService = /** @class */ (function () {
    function DynamicPortfolioService(portfolioService, currentLanguageProvider, kbService, dynamicCommunicationService, formResolverService, deService) {
        this.portfolioService = portfolioService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.kbService = kbService;
        this.dynamicCommunicationService = dynamicCommunicationService;
        this.formResolverService = formResolverService;
        this.deService = deService;
        this._searchNames = new Map();
        /**
         * Map containing filters for portfolio items.
         * @type {Map<any, any>}
         * @default
         * @private
         */
        this.filters = new Map();
        /**
         * Sorting options, used for getting portfolio items sorted.
         * @type {SortingOptions}
         * @default
         * @private
         */
        this._sortingOptions = undefined;
        this._portfolioRowsUpdateEvent = new ReplaySubject_1.ReplaySubject(1);
        this.columnFields = [];
    }
    Object.defineProperty(DynamicPortfolioService.prototype, "portfolioRowsUpdateEvent", {
        get: function () {
            return this._portfolioRowsUpdateEvent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicPortfolioService.prototype, "currentLanguageId", {
        get: function () {
            return this._currentLanguageId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicPortfolioService.prototype, "pageTotalCount", {
        get: function () {
            return this._pageTotalCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicPortfolioService.prototype, "portfolioColumns", {
        get: function () {
            return this._portfolioColumns;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicPortfolioService.prototype, "portfolioRows", {
        get: function () {
            return this._portfolioRows;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicPortfolioService.prototype, "searchNames", {
        get: function () {
            return this._searchNames;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicPortfolioService.prototype, "sortingOptions", {
        set: function (options) {
            this._sortingOptions = options;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicPortfolioService.prototype, "totalItemsCount", {
        get: function () {
            return this._totalItemsCount;
        },
        enumerable: true,
        configurable: true
    });
    DynamicPortfolioService.prototype.initFor = function (categorySystemName, columnSystemNames, pageLimit, filterKeys, defaultFilter, categoryPermissions) {
        var _this = this;
        if (defaultFilter) {
            this.filterOptions = defaultFilter.toJson();
            this.filters.set('default', defaultFilter);
        }
        this.categorySystemName = categorySystemName;
        this.pageLimit = pageLimit;
        this.categoryPermissionTypes = categoryPermissions;
        this.columnFields = this.processNestedColSystemNames(columnSystemNames);
        var entities$ = this.portfolioService.loadPortfolioItems(categorySystemName, new idm_de_core_frontend_1.PagingOptions(0, pageLimit), undefined, this.filterOptions, categoryPermissions);
        var metaFields$ = this.processColumnMetaFields(this.columnFields, this.categorySystemName);
        var metaCategory$ = this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(categorySystemName));
        var currentLanguage$ = this.currentLanguageProvider.getCurrentLanguage();
        return Observable_1.Observable.combineLatest(entities$, metaFields$, metaCategory$, currentLanguage$)
            .map(function (data) {
            var response = data[0], fields = data[1], category = data[2], language = data[3];
            _this.processMetaFrom(response);
            _this._portfolioColumns = fields;
            _this.nameMetaFieldIds = category.getNameMetaFieldIds();
            _this._currentLanguageId = language.getId();
            _this.processSearchFields(fields);
            _this._portfolioRows = _this.extractColumns(_this._portfolioColumns, response.getData(), _this.nameMetaFieldIds, _this.columnFields);
            _this._portfolioRowsUpdateEvent.next(_this.categorySystemName);
            _this.subscribeToFilters(filterKeys);
            return true;
        });
    };
    DynamicPortfolioService.prototype.ngOnDestroy = function () {
        this.portfolioProperties$ && this.portfolioProperties$.unsubscribe();
        this.quickFilter$ && this.quickFilter$.unsubscribe();
    };
    /**
     * @deprecated
     */
    DynamicPortfolioService.prototype.destroy = function () {
        console.warn('method is deprecated');
    };
    /**
     * Navigates to date entry form.
     * @param {number} entityInstanceId
     * @param {string} formName
     * @param {number} [formId=0]
     */
    DynamicPortfolioService.prototype.navigateToDeForm = function (entityInstanceId, formName, formId) {
        var _this = this;
        if (formId === void 0) { formId = 0; }
        var isAlreadyDeleted$ = new Subject_1.Subject();
        this.deService.loadEntityByInstanceId(this.categorySystemName, entityInstanceId).subscribe(function () {
            isAlreadyDeleted$.next(false);
            entityInstanceId !== undefined
                ? _this.formResolverService.navigateToViewDeForm(_this.categorySystemName, formName, entityInstanceId, formId)
                : _this.formResolverService.navigateToCreateNewDeForm(_this.categorySystemName, formName, formId);
        }, function (error) {
            if (error.status === 404) {
                isAlreadyDeleted$.next(true);
            }
        });
        return isAlreadyDeleted$;
    };
    DynamicPortfolioService.prototype.updatePortfolio = function (paging) {
        this.loadPortfolioItems(paging, this._sortingOptions, this.filterOptions, this.categoryPermissionTypes)
            .subscribe(function (_) {
        }, console.error);
    };
    DynamicPortfolioService.prototype.createFilterFrom = function (filters) {
        var filter;
        if (filters.size === 1) {
            filter = filters.values().next().value;
        }
        else {
            var builder_1 = new idm_de_core_frontend_1.FilterBuilder();
            Array.from(filters.entries()).forEach(function (value) {
                if (value[1] !== null && Object.keys(value[1].toJson()).length !== 0) {
                    builder_1.and(value[1]);
                }
            });
            filter = builder_1.build();
        }
        return (filter === undefined || filter === null) ? undefined : filter.toJson();
    };
    DynamicPortfolioService.prototype.extractColumns = function (portfolioFields, entities, nameMetaFieldIds, columnFields) {
        var _this = this;
        return entities.map(function (entity) {
            var cells = columnFields.map(function (columnField) {
                var isNameField = nameMetaFieldIds.find(function (metaFieldId) {
                    return metaFieldId.getSystemName() === columnField.systemName;
                }) !== undefined;
                if (columnField.isNested) {
                    var foundColumn = portfolioFields.find(function (portfolioField) { return columnField.nestedFieldSystemName === portfolioField.getSystemName(); });
                    if (!foundColumn) {
                        throw new Error("field " + columnField.nestedFieldSystemName + " was not found in portfolio fields");
                    }
                    else if (!columnField.nestedFieldSystemName) {
                        throw new Error('nested field system name of nested field was undefined');
                    }
                    else {
                        var columnMetaField = foundColumn;
                        if (entity.getProperty(columnField.systemName).value) {
                            return new portfolio_cell_model_1.PortfolioCellModel(columnMetaField, entity.getProperty(columnField.systemName).value
                                .getProperty(columnField.nestedFieldSystemName).value, isNameField);
                        }
                        else {
                            return new portfolio_cell_model_1.PortfolioCellModel(columnMetaField, _this.extractValueFromField(columnMetaField), isNameField);
                        }
                    }
                }
                else {
                    var foundColumn = portfolioFields.find(function (metaField) { return columnField.systemName === metaField.getSystemName(); });
                    if (!foundColumn) {
                        throw new Error("field " + columnField.systemName + " was not found in portfolio fields");
                    }
                    return new portfolio_cell_model_1.PortfolioCellModel(foundColumn, entity.getProperty(foundColumn.getSystemName()).value, isNameField);
                }
            });
            return new portfolio_row_model_1.PortfolioRowModel(cells, entity.getInstanceId());
        });
    };
    /**
     * Loads values from {@link PortfolioService} by paging, sorting and {@link categorySystemName}.
     * Updates {@link _portfolioRows}, which will cause changes in view.
     * @param {PagingOptions} pagingOptions
     * @param {SortingOptions} sortingOptions
     * @param {object} [filters]
     * @private
     */
    DynamicPortfolioService.prototype.loadPortfolioItems = function (pagingOptions, sortingOptions, filters, categoryPermissionTypes) {
        var _this = this;
        return this.portfolioService.loadPortfolioItems(this.categorySystemName, pagingOptions, sortingOptions, filters, categoryPermissionTypes)
            .map(function (data) {
            _this.processMetaFrom(data);
            _this._portfolioRows = _this.extractColumns(_this._portfolioColumns, data.getData(), _this.nameMetaFieldIds, _this.columnFields);
            _this._portfolioRowsUpdateEvent.next(_this.categorySystemName);
        });
    };
    /**
     * Processes metadata from {@link ServiceResponse}.
     * Gets all items count and calculates pages count.
     * @param {ServiceResponse<any>} serviceResponse
     * @private
     */
    DynamicPortfolioService.prototype.processMetaFrom = function (serviceResponse) {
        this._totalItemsCount = serviceResponse.getMeta().getTotalRowCount();
        this._pageTotalCount = Math.ceil(this._totalItemsCount / this.pageLimit);
    };
    DynamicPortfolioService.prototype.processSearchFields = function (allFields) {
        var _this = this;
        this._searchNames = new Map();
        allFields.forEach(function (field) {
            if (field.getType() === idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING) {
                _this._searchNames.set(field.getSystemName(), field.getSystemName() + "." + _this._currentLanguageId);
            }
            else if (!_this._searchNames.has(field.getSystemName())) {
                _this._searchNames.set(field.getSystemName(), field.getSystemName());
            }
        });
    };
    DynamicPortfolioService.prototype.subscribeToFilters = function (filterKeys) {
        var _this = this;
        this.portfolioProperties$ = this.dynamicCommunicationService.portfolioPropertiesObservable.filter(function (dto) {
            return filterKeys.find(function (key) {
                return key === dto.key;
            }) !== undefined;
        }).mergeMap(function (dto) {
            _this.filters.set(dto.key, dto.data);
            _this.filterOptions = _this.createFilterFrom(_this.filters);
            return _this.loadPortfolioItems(new idm_de_core_frontend_1.PagingOptions(0, _this.pageLimit), _this._sortingOptions, _this.filterOptions, _this.categoryPermissionTypes);
        }).catch(function (err, o) {
            console.error(err);
            return o;
        }).subscribe(function () { }, function (err) { return console.error(err); });
        this.quickFilter$ = this.dynamicCommunicationService.quickFilterObservable.mergeMap(function (quickFilterMap) {
            filterKeys.forEach(function (filterKey) {
                if (quickFilterMap.has(filterKey)) {
                    _this.filters.set(filterKey, quickFilterMap.get(filterKey));
                }
            });
            _this.filterOptions = _this.createFilterFrom(_this.filters);
            return _this.loadPortfolioItems(new idm_de_core_frontend_1.PagingOptions(0, _this.pageLimit), _this._sortingOptions, _this.filterOptions, _this.categoryPermissionTypes);
        }).catch(function (err, o) {
            console.error(err);
            return o;
        }).subscribe(function () { }, function (err) { return console.error(err); });
    };
    DynamicPortfolioService.prototype.processNestedColSystemNames = function (colSystemNames) {
        return colSystemNames.map(function (item) {
            var splits = item.split('.');
            return {
                isNested: splits.length > 1,
                nestedFieldSystemName: splits.length > 1 ? splits[1] : undefined,
                systemName: splits[0],
            };
        });
    };
    DynamicPortfolioService.prototype.processColumnMetaFields = function (columnFields, categorySystemName) {
        var _this = this;
        return this.kbService.getMetaFields(categorySystemName)
            .mergeMap(function (metaFields) {
            return Observable_1.Observable.zip.apply(Observable_1.Observable, columnFields.map(function (columnField) {
                if (!columnField.isNested) {
                    var columnMetaField = metaFields.find(function (metaField) {
                        return metaField.getSystemName() === columnField.systemName;
                    });
                    if (!columnMetaField) {
                        throw new Error("no field found for " + columnField.systemName + " column");
                    }
                    return Observable_1.Observable.of(columnMetaField);
                }
                else {
                    return _this.kbService.getMainEntityMetaFields(categorySystemName, columnField.systemName)
                        .map(function (mainEntityMetaFields) {
                        var mainEntityMetaField = mainEntityMetaFields.find(function (metaField) {
                            return metaField.getSystemName() === columnField.nestedFieldSystemName;
                        });
                        if (!mainEntityMetaField) {
                            throw new Error("no field found for " + columnField.systemName + " column");
                        }
                        return mainEntityMetaField;
                    });
                }
            }));
        });
    };
    DynamicPortfolioService.prototype.extractValueFromField = function (metaField) {
        return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING ?
            idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder().withValueForLanguage(this.currentLanguageId, '').build() : undefined;
    };
    DynamicPortfolioService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_de_service_client_js_1.PortfolioService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_kb_service_client_js_1.KbService,
            services_1.DynamicCommunicationService,
            idm_frontend_shared_1.FormResolverService,
            idm_de_service_client_js_1.DeService])
    ], DynamicPortfolioService);
    return DynamicPortfolioService;
}());
exports.DynamicPortfolioService = DynamicPortfolioService;
//# sourceMappingURL=dynamic-portfolio.service.js.map